import { TFunction } from "i18next";
import {
  AntennaDirection,
  IObservationIdentifier,
} from "../../core/api/observationIdentifiers/types";

const getDefaultRowValues = (
  observationIdentifier?: IObservationIdentifier,
) => {
  return {
    macAddress: observationIdentifier?.macAddress || "",
    antennaDirection:
      observationIdentifier?.antennaDirection || AntennaDirection.AntIn,
    observationIdentifier: observationIdentifier?.observationIdentifier || "",
  };
};

const getDefaultRowSetValues = () => ({
  dataDefinitions: [getDefaultRowValues()],
});

const getDefaultDropdownItems = (
  t: TFunction<"translation", undefined>,
  observationIdentifier?: IObservationIdentifier,
) => {
  return {
    selectedRoom: {
      name: t("Locations:BeaconType10"),
      isSelected: true,
      id: "10",
    },
    selectedOrganization: observationIdentifier?.organizationId
      ? {
          name: observationIdentifier.organizationName,
          isSelected: true,
          id: observationIdentifier.organizationId.toString(),
        }
      : null,
    selectedLocation: observationIdentifier?.knownLocationId
      ? {
          name: observationIdentifier.description,
          isSelected: true,
          id: observationIdentifier.knownLocationId.toString(),
        }
      : null,
  };
};

export { getDefaultDropdownItems, getDefaultRowValues, getDefaultRowSetValues };
